import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { requestChangeFAQ } from 'store/modules/faq/actions';
import { RootState } from 'types/store';

const mapStateToProps = (state: RootState) => ({
  index: state.faq.index,
  opacity: state.faq.opacity
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      changeItem: requestChangeFAQ
    },
    dispatch
  );

interface IFAQReduxState {
  readonly index: number;
  readonly opacity: boolean;
}

interface IFAQActions {
  changeItem: (index: number) => void;
}

export type WithFAQState = IFAQReduxState & IFAQActions;

const withFAQState = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withFAQState;



// WEBPACK FOOTER //
// ./src/enhancers/withFAQState.tsx